import {
  Component,
  computed,
  effect,
  inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';
import { ChartService } from '../../../services/line-values-chart..service';

type AccessibleChartRow = {
  label: string;
  value: string;
};

@Component({
  selector: 'app-line-values-modal',
  templateUrl: './line-values-modal.component.html',
  providers: [ChartService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LineValuesModalComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  readonly dialogRef = inject(MatDialogRef<LineValuesModalComponent>);

  readonly data = inject(MAT_DIALOG_DATA);

  // #region     BEGIN ChartService
  readonly chartService$ = inject(ChartService);

  get data$() {
    return this.chartService$.data$;
  }

  readonly updateChartEffect$ = effect(() => {
    this.data$();
    this.chart?.update();
  });
  // #endregion  END ChartService

  readonly chartTitle$ = computed(() => this.data$()?.title || 'Line chart');

  readonly chartValueHeader$ = computed(() => {
    const chartData = this.chartService$.lineChartData$();

    return chartData.datasets[0]?.label || this.data$()?.yAxisLabel || 'Value';
  });

  readonly accessibleChartRows$ = computed<AccessibleChartRow[]>(() => {
    const chartData = this.chartService$.lineChartData$();
    const labels = chartData.labels ?? [];
    const values = chartData.datasets[0]?.data ?? [];

    return labels.map((label, index) => ({
      label: String(label),
      value: String(values[index] ?? ''),
    }));
  });

  readonly chartDescription$ = computed(() => {
    const title = this.chartTitle$();
    const dataPointCount = this.accessibleChartRows$().length;
    const dataPointLabel = dataPointCount === 1 ? 'data point' : 'data points';

    return `${title} line chart with ${dataPointCount} ${dataPointLabel}. The data table lists each label and value.`;
  });

  ngOnInit(): void {
    this.data$.set(this.data);
  }
}
